import React, { useState, useEffect } from "react";
import { useAuth } from "../../../Context/AuthContext";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ClientNavtabs from "./ClientNavtabs";
const EditClientProfile = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const leadId = location.state?.leadId;
  const roleId = sessionStorage.getItem("roleId");
  const userId = sessionStorage.getItem("userId");
  // const token = sessionStorage.getItem("token");
  const apiUrl = process.env.REACT_APP_API_REST_URL;
  console.log(apiUrl, "apiUrl");
  const [currentUser, setCurrentUser] = useState("");
  const [rmOptions, setRmOptions] = useState([]);
  const [managerIdNameMap, setManagerIdNameMap] = useState({});
  const [leadData, setLeadData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onTouched" });
  const [states, setStates] = useState([]);
  // Handle menu navigation
  const handleMenuClick = (action) => {
    switch (action) {
      case "profile":
        // Already on profile page
        break;
      case "interactions":
        navigate("/employeedashboard/clients/interactions", {
          state: { leadId },
        });
        break;
      case "add-interaction":
        navigate("/employeedashboard/clients/add-interaction", {
          state: { leadId },
        });
        break;
      case "kyc":
        navigate("/employeedashboard/clients/kyc", {
          state: { leadId },
        });
        break;
      case "documents":
        // Navigate to documents
        break;
      case "add-business-numbers":
        navigate("/employeedashboard/clients/add-business-numbers", {
          state: { leadId },
        });
        break;
      case "business-numbers":
        navigate("/employeedashboard/clients/business-numbers", {
          state: { leadId },
        });
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const fetchLeadData = async () => {
      if (!leadId) {
        setIsLoading(false);
        setError("No lead ID provided");
        return;
      }

      try {
        setIsLoading(true);
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/referalEngine/getReferralById/${leadId}`
        );
        setLeadData(response.data);
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to load lead data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeadData();
  }, [leadId, apiUrl]);
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/commonEngine/state`
        );
        if (response.data.status) {
          setStates(response.data.response);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);
  // Populate form fields when component mounts
  useEffect(() => {
    if (leadData) {
      setValue("id", leadData.id);
      setValue("referralName", `${leadData.firstname} ${leadData.lastname}`);
      setCurrentUser(`${leadData.firstname} ${leadData.lastname}`);
      setValue("email", leadData.email);
      setValue("phone", leadData.phone);
      setValue("comments", leadData.comments);

      const formattedDate = leadData.firstContactDate
        ? leadData.firstContactDate.slice(0, 10)
        : "";
      setValue("firstContactDate", formattedDate);

      setValue("leadReferredBy", leadData.leadReferredBy);
      setValue("managerId", leadData.managerId);
      setValue("managerName", leadData.managerName);
      setValue("address1", leadData.address.address1);
      setValue("address2", leadData.address.address2);
      setValue("city", leadData.address.city);
      setValue("state", leadData.address.state);
      setValue("pincode", leadData.address.pincode);
      // setValue("location", leadData.location);
      setValue("automobileOwned", leadData.automobileOwned);
      setValue("description", leadData.description);
      setValue("clubMembership", leadData.clubMembership);
    }
  }, [leadData, setValue]);

  // Fetch RM options if role is admin
  useEffect(() => {
    const handleRole = async () => {
      try {
        const apiResult = await axios.post(
          `${apiUrl}/CCE/api/v1/userEngine/users`,
          {
            roleId: "1,2,6",
          }
        );
        const options = apiResult?.data?.response || [];
        setRmOptions(options);

        const idNameMap = options.reduce((map, option) => {
          map[option.id] = option.firstname + " " + option.lastname;
          return map;
        }, {});
        setManagerIdNameMap(idNameMap);
      } catch (error) {
        console.error("Error fetching rm data:", error.message);
      }
    };

    if (roleId === "1" || roleId === "6") {
      handleRole();
    }
  }, [roleId, apiUrl]);

  const handleReferralNameChange = (e) => {
    setValue("referralName", e.target.value);
  };

  const cancelHandler = () => {
    navigate("/employeedashboard/clients/view", { state: { leadId } });
  };

  const onSubmit = async (data) => {
    const headers = {
      "x-access-token": token,
    };
    const [firstname, lastname = ""] = data.referralName.split(" ");
    try {
      const response = await axios.put(
        `${apiUrl}/CCE/api/v1/referalEngine/updateReferral`,
        {
          ...data,
          referredId: leadData.id,
          firstname,
          lastname,
        },
        { headers }
      );

      if (response?.data?.statusMessage === "Success") {
        toast.success("Client updated successfully");

        // Update the lead data for the view page
        const updatedLeadData = {
          ...leadData,
          firstname,
          lastname,
          email: data.email,
          phone: data.phone,
          comments: data.comments,
          firstContactDate: data.firstContactDate,
          leadReferredBy: data.leadReferredBy,
          managerId: data.managerId,
          managerName: managerIdNameMap[data.managerId] || data.managerName,
          // location: data.location,
          address1: data.address1,
          address2: data.address2,
          city: data.city,
          pincode: data.pincode,
          state: data.state,
          automobileOwned: data.automobileOwned,
          description: data.description,
          clubMembership: data.clubMembership,
          updated_date: new Date().toISOString(),
          updated_by: userId,
        };

        // Navigate back to view page with updated data
        setTimeout(() => {
          navigate("/employeedashboard/clients/view", { state: { leadId } });
        }, 1000);
      } else {
        toast.error("Update failed");
      }
    } catch (error) {
      toast.error(
        "Update failed: " + (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <Box sx={styles.main_container}>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      />

      <Paper sx={styles.dashboard_paper}>
        <ClientNavtabs
          handleMenuClick={handleMenuClick}
          options={[
            {
              label: "Edit Profile",
              onClick: () => handleMenuClick("profile"),
            },
            {
              label: "View Interactions",
              onClick: () => handleMenuClick("interactions"),
            },
            {
              label: "Add Interaction",
              onClick: () => handleMenuClick("add-interaction"),
            },
            { label: "View KYC", onClick: () => handleMenuClick("kyc") },
            {
              label: "Upload Documents",
              onClick: () => handleMenuClick("documents"),
              disabled: true,
            },
            {
              label: "Add Business Numbers",
              onClick: () => handleMenuClick("add-business-numbers"),
            },
            {
              label: "View Business Numbers",
              onClick: () => handleMenuClick("business-numbers"),
            },
          ]}
        />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            p: 1,
            justifyContent: "flex-end",
            width: "25%",
            marginLeft: "auto",
          }}
        >
          <Button sx={styles.btn} variant="contained" onClick={cancelHandler}>
            Back
          </Button>
        </Box>
      </Paper>

      <Paper
        elevation={3}
        sx={{
          margin: "10px 20px 20px 20px",
          height: "590px",
          borderRadius: "12px",
        }}
      >
        <Typography
          variant="h6"
          component="h2"
          sx={{ marginBottom: "1rem", textAlign: "center", marginTop: "1rem" }}
        >
          Edit Client Profile:{" "}
          <span style={{ fontWeight: "bold" }}>{currentUser}</span>
        </Typography>
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100% - 80px)",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} my={1}>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Client Name"
                  variant="outlined"
                  {...register("referralName", {
                    required: "Client Name is required",
                    pattern: {
                      value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                  onChange={handleReferralNameChange}
                />
                {errors.referralName && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "65px",
                    }}
                  >
                    {errors.referralName.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Email Address"
                  variant="outlined"
                  {...register("email", {
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid Email Address",
                    },
                  })}
                />
                {errors.email && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "10px",
                    }}
                  >
                    {errors.email.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Phone Number"
                  variant="outlined"
                  inputProps={{ maxLength: 10 }}
                  {...register("phone", {
                    required: "Phone Number is required",
                    pattern: {
                      value: /^\d{10}$/,
                      message: "Invalid Phone Number (10 digits)",
                    },
                    validate: (value) => !!value || !!watch("email"),
                    onChange: (e) =>
                      (e.target.value = e.target.value.replace(/\D/g, "")),
                  })}
                />
                {errors.phone && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "65px",
                    }}
                  >
                    {errors.phone.message}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Comments (optional)"
                  variant="outlined"
                  {...register("comments", {})}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="First Contact Date"
                  type="date"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("firstContactDate", {
                    // required: "Date is required",
                  })}
                  InputProps={{
                    inputProps: {
                      placeholder: "Select Date",
                      max: new Date().toISOString().split("T")[0],
                    },
                  }}
                />
                {/* {errors.firstContactDate && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "65px",
                    }}
                  >
                    {errors.firstContactDate.message}
                  </div>
                )} */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="RRP Name"
                  variant="outlined"
                  {...register("leadReferredBy", {
                    // required: "Referred By is required",
                    pattern: {
                      value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />
                {/* {errors.leadReferredBy && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "65px",
                    }}
                  >
                    {errors.leadReferredBy.message}
                  </div>
                )} */}
              </Grid>

              {roleId === "2" && (
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    sx={styles.textfield}
                    label="Wealth Advisor"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    {...register("managerName")}
                  />
                </Grid>
              )}

              {(roleId === "1" || roleId === "6") && (
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" size="small">
                    <InputLabel
                      sx={{ fontSize: "13px" }}
                      id="rm-select-label"
                      shrink={!!watch("managerId")}
                    >
                      Wealth Advisor
                    </InputLabel>
                    <Controller
                      name="managerId"
                      control={control}
                      defaultValue={null}
                      rules={{
                        required: "Wealth Advisor is required",
                      }}
                      render={({ field }) => (
                        <Select
                          label="Wealth Advisor"
                          labelId="rm-select-label"
                          {...field}
                          sx={{ ...styles.textfield, textAlign: "left" }}
                          notched={!!field.value}
                        >
                          {rmOptions.map((option) => (
                            <MenuItem
                              key={option.id}
                              value={option.id}
                              sx={styles.menuItem}
                            >
                              {option.firstname} {option.lastname}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />
                  </FormControl>
                  {errors.managerId && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "14px",
                        textAlign: "left",
                        marginLeft: "10px",
                      }}
                    >
                      {errors.managerId.message}
                    </div>
                  )}
                </Grid>
              )}

              {/* <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Location"
                  variant="outlined"
                  {...register("location", {})}
                />
              </Grid> */}
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Address 1"
                  variant="outlined"
                  {...register("address1", {})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Address 2"
                  variant="outlined"
                  {...register("address2", {})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="City"
                  variant="outlined"
                  {...register("city", {})}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small" sx={styles.textfield}>
                  <InputLabel id="state-label" sx={{ fontSize: "13px" }}>
                    State
                  </InputLabel>
                  <Controller
                    name="state"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <Select
                        sx={{
                          "& .MuiSelect-select": {
                            textAlign: "left",
                          },
                        }}
                        labelId="state-label"
                        label="State"
                        {...field}
                        value={field.value || ""}
                      >
                        {states.map((state) => (
                          <MenuItem
                            key={state.id}
                            value={state.statename}
                            sx={styles.menuItem}
                          >
                            {state.statename}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="PIN code"
                  variant="outlined"
                  {...register("pincode", {
                    // required: "PIN code is required",
                    pattern: {
                      value: /^[0-9]{1,6}$/,
                      message: "Invalid characters in address",
                    },
                    validate: (value) => {
                      if (!value) return true;
                      return (
                        /^[0-9]{6}$/.test(value) ||
                        "PIN code must be exactly 6 digits"
                      );
                    },
                    onChange: (e) =>
                      (e.target.value = e.target.value.replace(/\D/g, "")),
                  })}
                  inputProps={{
                    maxLength: 6,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
                {errors.pincode && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      marginLeft: "60px",
                    }}
                  >
                    {errors.pincode.message}
                  </div>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Automobile Owned"
                  variant="outlined"
                  {...register("automobileOwned", {})}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Club Membership"
                  variant="outlined"
                  {...register("clubMembership", {})}
                />
              </Grid>

              {/* <Grid item xs={12} sm={4}>
                <TextField
                  size="small"
                  sx={styles.textfield}
                  label="Good About Referral"
                  variant="outlined"
                  {...register("description", {})}
                />
              </Grid> */}
            </Grid>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "2rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  "&:hover": { background: "#002C51" },
                }}
              >
                Update
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default EditClientProfile;
const styles = {
  main_container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "90vh",
    padding: "0px",
    margin: "0px",
    marginTop: "-25px",
    background: "#f2f2f2",
  },
  dashboard_paper: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "15px",
    margin: "0px 20px",
  },
  btn: {
    width: "80px",
    fontSize: "11px",
    marginTop: "3px",
    backgroundColor: "#002C51",
    color: "white",
    textTransform: "none",
    "&:hover": {
      background: "#002C51",
    },
  },
  textfield: {
    width: "340px",
    "& .MuiInputBase-input": {
      fontSize: "13px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "13px",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
      fontSize: "0.6em",
    },
    menuItem: {
      fontSize: "13px",
    },
  },
};
